<template>
    <div
        class="promo-bar w-full bg-deep-purple"
        :style="{ backgroundColor: promo.background_color, height: `${promo.banner_height}px` }"
    >
        <div class="content">
            <covid-19>
                <template v-slot:current>
                    <h4 v-if="!promo.desktop_image_url"
                        class="text-white text-center"
                        :style="{ color: promo.font_color }"
                        v-html="promo.content"
                    />
                    <a
                        v-else
                        :href="promo.external_url"
                    >
                        <img class="img-responsive" :src="promoImageSrc" alt="">
                    </a>
                </template>
                <template v-slot:covid>
                    <h4 v-if="!promo.desktop_image_url"
                        class="text-white text-center"
                        :style="{ color: promo.font_color }"
                        v-html="promo.content"
                        @click.prevent="covidBannerScroll"
                    />
                </template>
            </covid-19>
        </div>
        <button
            type="button"
            title="Close"
            class="close text-white text-light"
            @click="dismissPromo"
        >
            <span>X</span>
        </button>
    </div>
</template>

<script>
import { isMobile } from "../../util/helpers";
import Covid19 from "@c/covid-19";

export default {
    name: "PromoBar",
    props: {
        promo: {
            type: Object,
            required: true
        }
    },
    components: {
        Covid19
    },
    watch: {
       $route(to, from) {
           if (to.name == "home" && this.scroll == true) {
                this.$scrollTo("#prebuild-section", { offset: -90, duration: 1000 });
                this.scroll = false;
           }
        }
    },
    computed: {
        promoImageSrc() {
            return isMobile() ? this.promo.mobile_image_url : this.promo.desktop_image_url;
        }
    },
    data() {
        return {
            scroll: false
        }
    },
    methods: {
        dismissPromo() {
            this.$emit("removePromo", this.promo.id);
            sessionStorage.setItem("dismissPromo-" + this.promo.id, true);
        },
        covidBannerScroll() {
            if (this.$route.name != "home") {
                this.$router.push({ name: "home", hash: "#prebuild-section" });
            } else {
                this.$scrollTo("#prebuild-section", { offset: -90 });
            }
        }
    }
};
</script>
